import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@icon/clock.svg'


const _hoisted_1 = { class: "notification__update-time-left__item__header" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NotificationTemplate = _resolveComponent("NotificationTemplate")!

  return (_openBlock(), _createBlock(_component_NotificationTemplate, {
    notification: _ctx.notification,
    class: "notification__update-time-left"
  }, {
    pic: _withCtx(() => [
      _createVNode(_component_icon, {
        data: _imports_0,
        fill: true,
        width: "var(--icon-24)",
        height: "var(--icon-24)",
        class: "notification__update-time-left__icon"
      })
    ]),
    title: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "large",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "500"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" The time on these Tasks haven't been updated in quite some time ")
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notification?.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "notification__update-time-left__item"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("a", {
              class: "is-small-400 notification__update-time-left__item__number",
              target: "_blank",
              href: item?.url ?? '#'
            }, " #" + _toDisplayString(item.sequenceNumber), 9, _hoisted_2),
            _createVNode(_component_BaseSubHeading, {
              size: "medium",
              weight: "500",
              class: "is-ellipsis"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.tasks, (task, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              className: "notification__update-time-left__task"
            }, [
              _createVNode(_component_BaseSubHeading, {
                size: "medium",
                weight: "500",
                class: "notification__update-time-left__task__number"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(task.order), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_BaseSubHeading, {
                size: "medium",
                color: "monochrome-06",
                darkColor: "monochrome-03",
                weight: "400",
                class: "is-ellipsis notification__update-time-left__task__name"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(task.name), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_BaseSubHeading, {
                size: "small",
                weight: "500",
                className: "notification__update-time-left__task__estimation"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(task.estimatedHours) + " hr ", 1)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ]))
      }), 128)),
      (_ctx.$route.params.accountId)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: {
          name: 'myWork'
        },
            target: "_blank",
            class: "link is-large notification__update-time-left__view-my-work"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" View My Work ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["notification"]))
}